/**
 * Main admin dashboard content
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper } from '@mui/material';
import PageTitle from '../ui/PageTitle';
import Audits from './Audits';
import Communications from '../notification/Communications';

const styleSheet = theme => ({
    root: {
        width: '100%',
    },
    rootLoggedIn: {
        flexGrow: 1,
        //padding: 20,
    },
    paper: {
      padding: 16
    }
});

class AdminDashboard extends Component {
    render() {
        const classes = this.props.classes;

        return (
            <div className={classes.rootLoggedIn}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <PageTitle title="AppBind admin dashboard"/>
                </Grid>
                <Grid item xs={12}>
                  <Paper className={classes.paper}>
                    <Audits history={this.props.history}/>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper className={classes.paper}>
                    <Communications auth={this.props.auth} history={this.props.history}/>
                  </Paper>
                </Grid>
              </Grid>
            </div>
        );
    }
}

export default withStyles(styleSheet)(AdminDashboard);
